module.exports = __webpack_public_path__ + "static/timeline1999-fe37c0826be9bff5ad16b8ab72154bb0.jpeg";